import { z } from "zod";

export class ValidationError extends Error {
  constructor(public errors: z.ZodError) {
    super("Validation failed");
    this.name = "ValidationError";
  }
}

// Helper functions for safe FormData extraction
export function getStringFromFormData(formData: FormData, key: string, defaultValue: string = ""): string {
  const value = formData.get(key);
  return value !== null ? (value as string) : defaultValue;
}

export function getOptionalStringFromFormData(formData: FormData, key: string): string | undefined {
  const value = formData.get(key);
  if (value === null) return undefined;
  const stringValue = value as string;
  return stringValue.length > 0 ? stringValue : undefined;
}

export function formatValidationErrors(error: z.ZodError): string[] {
  return error.errors.map((err) => {
    let fieldName = err.path.join(".");
    
    // Convert technical field names to human-friendly names
    const fieldNameMap: Record<string, string> = {
      "title": "Title",
      "description": "Description", 
      "brandTitle": "Brand Title",
      "button.title": "Button Text",
      "button.url": "Button URL",
      "image.src": "Image",
      "image": "Image",
      "backgroundImage.src": "Background Image",
      "backgroundImage": "Background Image",
      "socialLinks": "Social Media Links",
      "colors": "Colors",
      "type": "Card Type",
      "links": "Links",
      "faqs": "FAQ Items",
      "whatsappNumber": "WhatsApp Number",
      "initialMessage": "Initial Message"
    };
    
    fieldName = fieldNameMap[fieldName] || fieldName;
    
    // Clean up the error message
    let message = err.message;
    if (message === "Required") {
      message = "This field is required";
    } else if (message.includes("Invalid url")) {
      message = "Please enter a valid URL";
    }
    
    return `${fieldName}: ${message}`;
  });
}
